import { render } from "./ModalSuccess.vue?vue&type=template&id=7ba6e38a"
import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"
script.render = render

export default script